import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';
import CopyIcon from '@material-ui/icons/FileCopySharp';
import { materialLinkClip, materialSrlClip } from '../utils/formatAppLib';
import { copySnippet } from '../utils/uiLib';

const CopyMidButton = ({ material, showAlert, className }) => {
  return (
    <Tooltip title='Copy MID to clipboard'>
      <IconButton
        id='button'
        color='secondary'
        size='small'
        className={className}
        onClick={(event) => {
          const item = (
            event.shiftKey ?
            materialLinkClip(material.materialId, material.name) : materialSrlClip(material.materialId)
          );
          copySnippet(item, showAlert, 'item');
          event.stopPropagation();
        }}
      >
        <CopyIcon />
      </IconButton>
    </Tooltip>
  );
};

export default CopyMidButton;
